import { FilterToolbarItem, FilterToolbarItemId } from 'src/components/Filters';
import { TicketStatusMultiSelector } from 'src/components/Selectors/TicketStatusSelector';
import { ContentId } from 'src/utils/constants/contentId';

type TicketStatusFilter = {
  ticketStatuses: string[] | null;
};

export const useTicketStatusFilters = <TFilter extends TicketStatusFilter>({
  query,
  setQuery,
}: {
  query: TFilter;
  setQuery: (query: TFilter) => void;
}): FilterToolbarItem => {
  return {
    filterId: 'ticketStatuses' as FilterToolbarItemId,
    labelContentId: ContentId.TicketStatus,
    filterQueryKeys: ['ticketStatuses'] as FilterToolbarItemId[],
    filterItem: (
      <TicketStatusMultiSelector
        values={query.ticketStatuses ?? []}
        triggerProps={{ style: { width: '100%' } }}
        placeholderText={ContentId.All}
        enableEmptySelection
        onChange={({ newValues: newStatuses }) => {
          if (newStatuses !== query.ticketStatuses) {
            setQuery({
              ...query,
              ticketStatuses: newStatuses?.length ? newStatuses : null,
            });
          }
        }}
      />
    ),
  };
};
